(function($) {

//--------------------------
// SOFTSCROLL
//--------------------------

$(function() {
  $('.softscroll').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top - 92
        }, 800);
        return false;
      }
    }
  });
});

//--------------------------
// NAV TIDY
//--------------------------

var browserWidth = window.innerWidth || document.documentElement.clientWidth;

function tidyup() {
  
  var $browserWidth = window.innerWidth || document.documentElement.clientWidth;

  if ($browserWidth > 1099) {
    //mainnav
    $('header .main_block').show();
    $("#burger").removeClass('on');
    //subnav
    $('header .bottom.active').show();

  } else {
    $('header .bottom.active').hide();
  }
    
};

//--------------------------
// SCROLLMAGIC
//--------------------------

var scrollMagicController = null;
var scrollMagicScenes = {};
var resizeTimer = null;

function clearScrollMagic() {
  $.each(scrollMagicScenes, function(targetID, scene) {
    scene.destroy(true);
  });

  scrollMagicScenes = {};

  if (scrollMagicController) {
    scrollMagicController.destroy(true);
    scrollMagicController = null;
  }
}

function whereTheMagicHappens() {
  if (typeof window.ScrollMagic === 'undefined') {
    return;
  }

  var $targets = $('.toggle_trans[id]');
  var activeTargets = {};

  if (!$targets.length) {
    clearScrollMagic();
    return;
  }

  if (!scrollMagicController) {
    scrollMagicController = new window.ScrollMagic.Controller();
  }

  $targets.each(function () {
    var targetID = this.id;
    var elementHeight = $(this).outerHeight();

    activeTargets[targetID] = true;

    if (scrollMagicScenes[targetID]) {
      scrollMagicScenes[targetID].duration(elementHeight);
      scrollMagicScenes[targetID].refresh();
      scrollMagicScenes[targetID].update(true);
      return;
    }

    scrollMagicScenes[targetID] = new window.ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 'onLeave',
      offset: -92,
      duration: elementHeight
    })
    .setClassToggle("header", "transparent");

    scrollMagicController.addScene(scrollMagicScenes[targetID]);
  });

  $.each(scrollMagicScenes, function(targetID, scene) {
    if (!activeTargets[targetID]) {
      scene.destroy(true);
      delete scrollMagicScenes[targetID];
    }
  });
}

function handleResize() {
  tidyup();
  whereTheMagicHappens();

  var $browserWidth = window.innerWidth || document.documentElement.clientWidth;

  if ($browserWidth < 768) {
    $(".footer_title").removeClass("active");
    $(".footer_title").next(".footer_links").slideUp(300);
  } else {
    $(".footer_title").removeClass("active");
    $(".footer_title").next(".footer_links").slideDown(300);
  }
}

function debounceResize() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(handleResize, 150);
}

//--------------------------
// WINDOW LOAD
//--------------------------

$(window).on('load', function(){
  whereTheMagicHappens();
});

//--------------------------
// WINDOW RESIZE
//--------------------------

$(window).resize(function () {
  debounceResize();
});

//--------------------------
// DOCUMENT READY
//--------------------------

$(document).ready(function(){
  
  if ($.fn.stellar && $('[data-stellar-ratio], [data-stellar-background-ratio]').length) {
    $.stellar();
  }

  $(window).scroll(function() {
    if ($(document).scrollTop() >= 1) {
        $('header').css('border-bottom', 'solid 1px #F1F4F6');
        $('header.transparent').css('border-bottom', 'none');
    }
    else {
        $('header').css('border-bottom', 'none');
    }
  });

  $("#burger").click(function() {
    if ($(this).hasClass('on')) {
      $('header .main_block').fadeOut(300);
      $(this).removeClass('on');
      $('body').removeClass('lock');

    } else {
      $('header .main_block').fadeIn(300);
      $(this).addClass('on');
      $('body').addClass('lock');
    }
  }); 

  if (typeof window.Swiper !== 'undefined' && $('.swiper-container').length) {
    new window.Swiper ('.swiper-container', {
      // Optional parameters
      //loop: true,
      autoplay: 8000,
      autoplayDisableOnInteraction: true,
      pagination: '.swiper-pagination',
      paginationClickable: true,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev'
    });
  }

  $("#services_link").hover(function() {
    $(this).toggleClass('activate');
    $('#sectors_link').toggleClass('deactivate');
  }); 

  $("#sectors_link").hover(function() {
    $(this).toggleClass('activate');
    $('#services_link').toggleClass('deactivate');
  }); 

  $("input, textarea").focusin(function(){
    $(this).addClass('active_label');
  });

  $("input, textarea").focusout(function(){
    var tmpval = $(this).val();
    if(tmpval == '') {
        $(this).removeClass('active_label');
    } else {
        $(this).addClass('active_label');
    }
  });

  $(".open_modal").click(function(e) {
    var target = '#' + $(this).data('target');
    $(target).fadeIn();
    $('body').addClass('lock');
  }); 

  $(".close_modal").click(function() {
    $('.overlay').fadeOut();
    $('body').removeClass('lock');
  });

  //--------------------------
  // Read More
  //--------------------------

  var $expand = $('#expand');
  var $readshort = $('#readshort');

  if ($expand.length && $readshort.length) {
    var expandHeight = $expand.outerHeight();
    var expandedHeight = $expand.prop('scrollHeight');

    if (expandedHeight > expandHeight + 1) {
      $readshort.removeAttr('hidden');
    }
  }

  $readshort.on('click', function() {

    var expandedHeight = $expand.prop('scrollHeight'); 

    if ($expand.hasClass('expanded')) {
      $expand.removeAttr('style');
      $expand.removeClass('expanded');
    } else {
      $expand.css({'max-height': expandedHeight});
      $expand.addClass('expanded');
    }

    var link = document.getElementById('readshort');

    if (link.innerHTML === 'Read more') link.innerHTML = 'Read less';
    else {
        link.innerHTML = 'Read more';
    }

  });

  //--------------------------
  // Dropdowns
  //--------------------------

  $("#sublabel").click(function() {
    $(this).toggleClass('active');
    $(this).next('header .bottom').slideToggle();
  });

  $(".dropdown .label").click(function() {
    $(this).toggleClass('active');
    $(this).next('.link_wrapper').slideToggle();
  });

  //--------------------------
  // IE Only (SVG Fill & Greyscale)
  //--------------------------
  
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
  {
    $('body').addClass('ie');
    if ($.fn.gray) {
      $('.grayie').gray();
    }
  }

  whereTheMagicHappens();

  $(".footer_title").click(function() {
    var $browserWidth = window.innerWidth || document.documentElement.clientWidth;

    if ($browserWidth < 768) {
      $(this).toggleClass("active");
      $(this).next(".footer_links").slideToggle(300);
    }
  });

});

})(jQuery);
